import script from "./g-header.vue?vue&type=script&setup=true&lang=js"
export * from "./g-header.vue?vue&type=script&setup=true&lang=js"

import "./g-header.vue?vue&type=style&index=0&id=425bda1b&lang=scss&scoped=true"

import exportComponent from "/root/workspace/theone-chain-wallet_bUmu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-425bda1b"]])

export default __exports__